exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n/*.el-select-dropdown__wrap{*/\r\n/*    max-height: 800px;*/\r\n/*}*/\r\n", ""]);

// exports
